import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { slugify } from '@powdr/utils';

import {
  TextMeasurementContent, TextMeasurementIcon,
  TextMeasurementItem, TextMeasurementLabel,
  TextIconContainer,
  StatusDot,
} from './styles';

export const TextHours = ({
  colorProfile = null,
  colorOverride = null,
  label = null,
  measurement = null,
  icon = null,
  hours = null,
}) => (
  <TextMeasurementItem className={`text-measurement ${slugify(measurement)} add-gap`}>
    <TextIconContainer>
      {(icon) && (
        <TextMeasurementIcon
          className="icon text-hours"
          name={icon}
          $colorProfile={colorProfile}
        />
      )}
      <TextMeasurementLabel
        className="label no-margin text-hours"
      >
        {label}
      </TextMeasurementLabel>
    </TextIconContainer>
    <TextIconContainer>
      <StatusDot $colorOverride={colorOverride} />
      <TextMeasurementContent
        className={classNames('content text-hours')}
      >
        {hours?.map((h) => <span>{h}</span>)}
      </TextMeasurementContent>
    </TextIconContainer>
  </TextMeasurementItem>
);

TextHours.propTypes = {
  colorProfile: PropTypes.string,
  colorOverride: PropTypes.string,
  label: PropTypes.string,
  measurement: PropTypes.string,
  icon: PropTypes.string,
  hours: PropTypes.string,
};
